<div class="page">
  <app-page-header
    [title]="
      'Account.WelcomeMessage'
        | i18next : { username: userAttributes | username }
    "
    [showAreaPlaceholder]="isBusy"
  >
    <app-account-picture
      pre-title-view
      [image]="imageContent"
    ></app-account-picture>
    <dx-button
      [text]="'Account.EditProfile' | i18next"
      type="default"
      icon="edit"
      (onClick)="editProfile()"
    ></dx-button>
  </app-page-header>

  <app-widget-card
    *ngIf="displayLicenses"
    [showAreaPlaceholder]="isBusy"
    minHeight="450px"
    icon="assets/icons/ic_license.svg"
    [title]="'Installations.Licenses' | i18next"
    [showAreaPlaceholder]="isBusy"
  >
    <app-licenses-list
      [installationLicenses]="userLicenses"
      [installations]="userInstallations"
    ></app-licenses-list>
  </app-widget-card>

  <!-- Installations -->
  <app-entity-carousel
    [title]="'General.Installations' | i18next"
    [items]="userInstallations"
    [actionText]="'Installations.CreateInstallation' | i18next"
    actionIcon="add"
    (actionClick)="createInstallation()"
    [isBusy]="isBusy">

    <ng-template #cardTemplate let-installation>
      <div class="installation-card">
        <div class="installation-card-image-wrapper">
          <img
            alt="{{ installation.name }}"
            [src]="installation.image_url ?? 'assets/images/background.jpeg'"
            [class.blurred]="!(installation | hasLicense : userLicenses)"
          />
          <div
            class="no-license-overlay"
            *ngIf="!(installation | hasLicense : userLicenses)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="white">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z"/>
            </svg>
            <span>{{ 'Installations.NoLicense' | i18next }}</span>
          </div>
        </div>
        <div class="installation-info">
          <div class="installation-name">{{ installation.name }}</div>
          <div class="installation-address">
            <div class="installation-address-content">
              {{ installation?.address?.address }}
            </div>
          </div>
          <div class="installation-actions flex">
            <dx-button
              text="Manage"
              type="default"
              icon="chart"
              (onClick)="openInstallationDetail(installation)"
              [disabled]="!(installation | hasLicense : this.userLicenses)"
            ></dx-button>

            <dx-button
              [text]="'Installations.License' | i18next"
              type="default"
              icon="add"
              (onClick)="showAddLicenseDialog(installation)"
              [visible]="!(installation | hasLicense : this.userLicenses) && (installation.permissions | installerAccess)"
            ></dx-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #listTemplate>
      <app-widget-card [showAreaPlaceholder]="isBusy">
        <dx-data-grid
          [dataSource]="userInstallations"
          [hoverStateEnabled]="true"
          [allowColumnResizing]="true"
          (onRowClick)="openInstallationDetail($event.data)">
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-header-filter visible="true"></dxo-header-filter>
          <dxi-column dataField="name" [caption]="'General.Name' | i18next" [allowHiding]="false"></dxi-column>
          <dxi-column dataField="timestamp" [caption]="'General.CreatedOn' | i18next" alignment="center" cellTemplate="dateCell" [allowFiltering]="false">
            <div *dxTemplate="let cellInfo of 'dateCell'">
              {{ cellInfo.value * 1000 | date : "longDate" }}
            </div>
          </dxi-column>
          <dxi-column dataField="language" [caption]="'Installations.SelectedLanguage' | i18next" alignment="center"></dxi-column>
          <dxi-column dataField="address.address" [caption]="'General.Address' | i18next" alignment="center"></dxi-column>
        </dx-data-grid>
      </app-widget-card>
    </ng-template>

  </app-entity-carousel>

  <!-- Units -->
  <app-entity-carousel
    [title]="'General.Unit' | i18next"
    [items]="userUnits">

    <ng-template #cardTemplate let-unit>
      <div class="entity-card" (click)="openUnitDashboard(unit)">
        <img
          alt="{{ unit.name }}"
          [src]="unit.image_url ?? 'assets/images/background.jpeg'"
        />
        <div class="entity-info">
          <div class="entity-name">{{ unit.name }}</div>
          <div class="entity-subtitle">{{ unit.location }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template #listTemplate>
      <app-widget-card>
        <dx-data-grid
          [dataSource]="userUnits"
          [hoverStateEnabled]="true"
          [allowColumnResizing]="true"
          (onRowClick)="openUnitDashboard($event.data)">
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-header-filter visible="true"></dxo-header-filter>
          <dxi-column dataField="name" [caption]="'General.Name' | i18next" [allowHiding]="false"></dxi-column>
          <dxi-column dataField="location" [caption]="'General.Address' | i18next" alignment="center"></dxi-column>
        </dx-data-grid>
      </app-widget-card>
    </ng-template>

  </app-entity-carousel>

  <!-- PBXs -->
  <app-entity-carousel
    [title]="'General.Pbxs' | i18next"
    [items]="userPbxs">

    <ng-template #cardTemplate let-pbx>
      <div class="entity-card" (click)="openPbxDashboard(pbx)">
        <img
          alt="{{ pbx.name }}"
          [src]="pbx.image_url ?? 'assets/images/background.jpeg'"
        />
        <div class="entity-info">
          <div class="entity-name">{{ pbx.name }}</div>
          <div class="entity-subtitle">{{ pbx.location }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template #listTemplate>
      <app-widget-card>
        <dx-data-grid
          [dataSource]="userPbxs"
          [hoverStateEnabled]="true"
          [allowColumnResizing]="true"
          (onRowClick)="openPbxDashboard($event.data)">
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-header-filter visible="true"></dxo-header-filter>
          <dxi-column dataField="name" [caption]="'General.Name' | i18next" [allowHiding]="false"></dxi-column>
          <dxi-column dataField="location" [caption]="'General.Address' | i18next" alignment="center"></dxi-column>
        </dx-data-grid>
      </app-widget-card>
    </ng-template>

  </app-entity-carousel>

</div>

<app-shimmer-overlay *ngIf="isBusy"></app-shimmer-overlay>
